import {
  Box,
  Button,
  Card,
  Divider,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useSnackbar } from "notistack";
import AppButton from "../../components/app-button/AppButton";
import AppDialog from "../../components/app-dialog/AppDialog";
import Iconify from "../../components/iconify/Iconify";
import { IMAGE_URL } from "../../constants/Images";

function About(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [editBusinessDialog, setEditBusinessDialog] = useState(false);
  const [editBusinessAddressDialog, setEditBusinessAddressDialog] =
    useState(false);
  const [editBusinessAboutDialog, setEditBusinessAboutDialog] = useState(false);
  const [editBusinessLogoDialog, setEditBusinessLogoDialog] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [businessAbout, setBusinessAbout] = useState("");
  const [address, setAddress] = useState("");
  const [landmark, setLandmark] = useState("");
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [value, setValue] = React.useState(0);
  const inputFile = useRef(null);
  const [file, setFile] = useState("");
  const [fileData, setFileData] = useState("");
  const [fileStatus, setFileStatus] = useState("");
  const [businessLogo, setBusinessLogo] = useState("");
  const editorRef = useRef(null);
  const storeId = null;
  const details = {
    store_name: "Sana Cafe",
    address: "E 1503, Yashone Hinjewadi",
    area: "Hinjewadi",
    city: "pune",
    pinCode: 411017,
    landmark: "",
    about: "This is about cafe",
    gstn: 5465466,
  };

  const handleDialogCancel = () => {
    setEditBusinessDialog(false);
    setEditBusinessAddressDialog(false);
    setEditBusinessAboutDialog(false);
    setEditBusinessLogoDialog(false);
  };

  const handleEditBusinessName = () => {
    setEditBusinessDialog(true);
    setBusinessName(details?.store_name);
  };

  const handleFileClick = () => {
    inputFile.current.click();
  };

  const handleFileChange = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
    setFileData(e.target.files[0]);
    setFileStatus("removed");
    setBusinessLogo("");
  };

  const handleFileRemove = () => {
    setFile("");
    setFileData("");
    inputFile.current.value = "";
    setFileStatus("removed");
  };

  const updateBusinessNameClick = async () => {
    // if (businessName === "") {
    //   enqueueSnackbar("Please enter business name.", { variant: "error" });
    //   return;
    // }
    // try {
    //   setIsLoading(true);
    //   let formData = new FormData();
    //   formData.append(
    //     "form_data",
    //     JSON.stringify({
    //       store_id: storeId,
    //       field_name: "name",
    //       name: businessName,
    //     })
    //   );
    //   const res = await dispatch(updateStoreByField(formData));
    //   await dispatch(getStoreDetails(storeId));
    //   setIsLoading(false);
    //   handleDialogCancel();
    //   enqueueSnackbar(res.data.message, { variant: "success" });
    // } catch (err) {
    //   setIsLoading(false);
    //   if (err?.errors) {
    //     enqueueSnackbar(err?.errors?.message, { variant: "error" });
    //   }
    // }
  };

  //Business Address
  const handleEditBusinessAddress = async () => {
    // setEditBusinessAddressDialog(true);
    // setAddress(details?.address);
    // setLandmark(details?.landmark);
    // setArea(details?.area);
    // setCity(details?.city);
    // setPinCode(details?.pinCode);
  };

  const updateBusinessAddressClick = async () => {
    // try {
    //   setIsLoading(true);
    //   const obj = JSON.stringify({
    //     store_id: storeId,
    //     address: address,
    //     landmark: landmark,
    //     area: area,
    //     city: city,
    //     pin_code: pinCode,
    //   });
    //   const res = await dispatch(updateStoreAddress(obj));
    //   await dispatch(getStoreDetails(storeId));
    //   setIsLoading(false);
    //   handleDialogCancel();
    //   enqueueSnackbar(res.data.message, { variant: "success" });
    // } catch (err) {
    //   setIsLoading(false);
    //   if (err?.errors) {
    //     enqueueSnackbar(err?.errors?.message, { variant: "error" });
    //   }
    // }
  };

  //Business About
  const handleEditBusinessAbout = async () => {
    setBusinessAbout(details?.about);
    setEditBusinessAboutDialog(true);
  };

  const updateBusinessAboutClick = async () => {
    // try {
    //   setIsLoading(true);
    //   let formData = new FormData();
    //   let businessAbout = "";
    //   if (editorRef.current) {
    //     businessAbout = editorRef.current.getContent();
    //   }
    //   formData.append(
    //     "form_data",
    //     JSON.stringify({
    //       store_id: storeId,
    //       field_name: "about",
    //       name: businessAbout,
    //     })
    //   );
    //   const res = await dispatch(updateStoreByField(formData));
    //   await dispatch(getStoreDetails(storeId));
    //   setIsLoading(false);
    //   handleDialogCancel();
    //   enqueueSnackbar(res.data.message, { variant: "success" });
    // } catch (err) {
    //   setIsLoading(false);
    //   if (err?.errors) {
    //     enqueueSnackbar(err?.errors?.message, { variant: "error" });
    //   }
    // }
  };

  //Business Logo
  const handleBusinessLogo = async () => {
    setBusinessLogo(details?.logo);
    setFile(details?.logo);
    setEditBusinessLogoDialog(true);
  };

  const updateBusinessLogoClick = async () => {
    // try {
    //   setIsLoading(true);
    //   let formData = new FormData();
    //   if (fileData) {
    //     formData.append("user_file", fileData);
    //   }
    //   formData.append(
    //     "form_data",
    //     JSON.stringify({
    //       store_id: storeId,
    //       field_name: "img",
    //       name: fileStatus,
    //     })
    //   );
    //   const res = await dispatch(updateStoreByField(formData));
    //   await dispatch(getStoreDetails(storeId));
    //   setIsLoading(false);
    //   handleDialogCancel();
    //   enqueueSnackbar(res.data.message, { variant: "success" });
    // } catch (err) {
    //   setIsLoading(false);
    //   if (err?.errors) {
    //     enqueueSnackbar(err?.errors?.message, { variant: "error" });
    //   }
    // }
  };

  const dialogEditBusinessAboutFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={handleDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isLoading}
          isLoading={isLoading}
          fullWidth
          size="medium"
          onClick={updateBusinessAboutClick}
          variant="contained"
        >
          Save
        </AppButton>
      </Box>
    </>
  );

  const dialogEditBusinessFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={handleDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isLoading}
          isLoading={isLoading}
          fullWidth
          size="medium"
          onClick={updateBusinessNameClick}
          variant="contained"
        >
          Save
        </AppButton>
      </Box>
    </>
  );

  const dialogEditAddressFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={handleDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isLoading}
          isLoading={isLoading}
          fullWidth
          size="medium"
          onClick={updateBusinessAddressClick}
          variant="contained"
        >
          Save
        </AppButton>
      </Box>
    </>
  );

  return (
    <>
      <Box>
        <Card>
          <Box style={{ padding: 20 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography
                gutterBottom
                style={{
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: " rgb(99, 115, 129)",
                  fontWeight: 700,
                }}
              >
                Business Name
              </Typography>
              <Button
                onClick={handleEditBusinessName}
                size="small"
                variant="text"
                startIcon={<Iconify icon="eva:edit-fill" />}
                style={{
                  color: "rgb(0, 171, 85)",
                }}
              >
                Edit
              </Button>
            </Stack>
            <Box>
              <Typography
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                }}
              >
                {details?.store_name}
              </Typography>
            </Box>
          </Box>
          <Divider className="s-divider" />
          <Box style={{ padding: 20 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography
                gutterBottom
                style={{
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: " rgb(99, 115, 129)",
                  fontWeight: 700,
                }}
              >
                Location
              </Typography>
              <Button
                size="small"
                variant="text"
                startIcon={<Iconify icon="eva:edit-fill" />}
                onClick={handleEditBusinessAddress}
                style={{
                  color: "rgb(0, 171, 85)",
                }}
              >
                Edit
              </Button>
            </Stack>
            <Box>
              {true ? (
                <Box>
                  <Typography
                    style={{
                      fontSize: 14,
                    }}
                  >
                    {details?.address}, {details?.area}, {details?.city}{" "}
                    {details?.pinCode}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: 13,
                      color: "#6a5e5e",
                    }}
                  >
                    {details?.landmark ? `Landmark: ${details?.landmark}` : ""}
                  </Typography>
                </Box>
              ) : (
                <Button
                  onClick={handleEditBusinessAddress}
                  size="small"
                  variant="text"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  style={{
                    color: "rgb(0, 171, 85)",
                  }}
                >
                  Add Address
                </Button>
              )}
            </Box>
          </Box>
          <Divider className="s-divider" />
          <Box style={{ padding: 20 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography
                gutterBottom
                style={{
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: " rgb(99, 115, 129)",
                  fontWeight: 700,
                }}
              >
                About
              </Typography>
              {details?.about && (
                <Button
                  onClick={handleEditBusinessAbout}
                  size="small"
                  variant="text"
                  startIcon={<Iconify icon="eva:edit-fill" />}
                  style={{
                    color: "rgb(0, 171, 85)",
                  }}
                >
                  Edit
                </Button>
              )}
            </Stack>
            <Box>
              {details?.about ? (
                <Box
                  style={{
                    fontSize: 14,
                  }}
                  dangerouslySetInnerHTML={{ __html: details?.about }}
                ></Box>
              ) : (
                <Button
                  onClick={handleEditBusinessAbout}
                  size="small"
                  variant="text"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  style={{
                    color: "rgb(0, 171, 85)",
                  }}
                >
                  Add About
                </Button>
              )}
            </Box>
          </Box>
          <Divider className="s-divider" />
          <Box style={{ padding: 20 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography
                gutterBottom
                style={{
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: " rgb(99, 115, 129)",
                  fontWeight: 700,
                }}
              >
                GSTN Number
              </Typography>
              {details?.gstn && (
                <Button
                  onClick={handleEditBusinessAbout}
                  size="small"
                  variant="text"
                  startIcon={<Iconify icon="eva:edit-fill" />}
                  style={{
                    color: "rgb(0, 171, 85)",
                  }}
                >
                  Edit
                </Button>
              )}
            </Stack>
            <Box>
              {details?.gstn ? (
                <Box
                  style={{
                    fontSize: 14,
                  }}
                >
                  {details?.gstn}
                </Box>
              ) : (
                <Button
                  onClick={handleEditBusinessAbout}
                  size="small"
                  variant="text"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  style={{
                    color: "rgb(0, 171, 85)",
                  }}
                >
                  Add GSTN Number
                </Button>
              )}
            </Box>
          </Box>
          <Divider className="s-divider" />
          <Box style={{ padding: 20 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography
                gutterBottom
                style={{
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: " rgb(99, 115, 129)",
                  fontWeight: 700,
                }}
              >
                Business Logo
              </Typography>
              {details?.logo && (
                <Button
                  onClick={handleBusinessLogo}
                  size="small"
                  variant="text"
                  startIcon={<Iconify icon="eva:edit-fill" />}
                  style={{
                    color: "rgb(0, 171, 85)",
                  }}
                >
                  Edit
                </Button>
              )}
            </Stack>
            <Box>
              <Box>
                {details?.logo ? (
                  <Box sx={{ mb: 2 }}>
                    <Box className="c-image-wrap c-item-image-wrap">
                      <img
                        src={
                          details?.logo
                            ? `${IMAGE_URL}store/logo/thumbnail?id=${storeId}&img_id=${details.logo}`
                            : file
                        }
                        alt="img"
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Button
                    onClick={handleBusinessLogo}
                    size="small"
                    variant="text"
                    startIcon={<Iconify icon="eva:plus-fill" />}
                    style={{
                      color: "rgb(0, 171, 85)",
                    }}
                  >
                    Add Logo
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>

      {editBusinessDialog && (
        <AppDialog
          maxWidth="xs"
          isOpen={editBusinessDialog}
          id={"edit_business_name_dialog"}
          title={<>{"Business Name"}</>}
          footer={dialogEditBusinessFooter}
        >
          <Box>
            <Stack
              spacing={3}
              style={{
                marginTop: 30,
                marginBottom: 30,
              }}
            >
              <TextField
                autoFocus
                label="Business Name*"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="businessName"
                value={businessName}
                onChange={(event) => setBusinessName(event.target.value)}
              />
            </Stack>
          </Box>
        </AppDialog>
      )}

      {editBusinessAddressDialog && (
        <AppDialog
          maxWidth="xs"
          isOpen={editBusinessAddressDialog}
          id={"edit_business_address_dialog"}
          title={<>{"Business Address"}</>}
          footer={dialogEditAddressFooter}
        >
          <Box>
            <Stack
              spacing={3}
              style={{
                marginTop: 30,
                marginBottom: 30,
              }}
            >
              <TextField
                multiline
                rows={2}
                autoFocus
                label="Address*"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="address"
                value={address}
                onChange={(event) => setAddress(event.target.value)}
              />
              <TextField
                autoFocus
                label="Landmark (Optional)"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="landmark"
                value={landmark}
                onChange={(event) => setLandmark(event.target.value)}
              />
              <TextField
                autoFocus
                label="Area*"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="area"
                value={area}
                onChange={(event) => setArea(event.target.value)}
              />
              <TextField
                autoFocus
                label="City*"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="city"
                value={city}
                onChange={(event) => setCity(event.target.value)}
              />
              <TextField
                autoFocus
                label="Pincode*"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="pinCode"
                value={pinCode}
                onChange={(event) => setPinCode(event.target.value)}
              />
            </Stack>
          </Box>
        </AppDialog>
      )}

      {editBusinessAboutDialog && (
        <AppDialog
          maxWidth="xs"
          isOpen={editBusinessAboutDialog}
          id={"edit_business_about_dialog"}
          title={<>{"About"}</>}
          footer={dialogEditBusinessAboutFooter}
        >
          <Box>
            <Stack
              spacing={3}
              style={{
                marginTop: 30,
                marginBottom: 30,
              }}
            >
              <TextField
                multiline
                rows={4}
                autoFocus
                label="Business About"
                fullWidth
                placeholder=""
                autoComplete="off"
                name="businessAbout"
                value={businessAbout}
                onChange={(event) => setBusinessAbout(event.target.value)}
              />
            </Stack>
          </Box>
        </AppDialog>
      )}

      {editBusinessLogoDialog && (
        <AppDialog
          maxWidth="xs"
          isOpen={editBusinessLogoDialog}
          id={"edit_business_logo_dialog"}
          title={<>{"Business Logo"}</>}
          footer={
            <>
              <Box
                style={{
                  display: "flex",
                  gap: 15,
                }}
              >
                <Button size="medium" onClick={handleDialogCancel}>
                  Cancel
                </Button>
                <AppButton
                  disabled={isLoading}
                  isLoading={isLoading}
                  fullWidth
                  size="medium"
                  onClick={updateBusinessLogoClick}
                  variant="contained"
                >
                  Save
                </AppButton>
              </Box>
            </>
          }
        >
          <Box>
            <Stack
              spacing={3}
              style={{
                marginTop: 30,
                marginBottom: 30,
              }}
            >
              <Box className="c-image-wrap c-item-image-wrap">
                <input
                  onChange={(event) => handleFileChange(event)}
                  accept="image/*"
                  type="file"
                  ref={inputFile}
                  style={{ display: "none" }}
                />
                {!file ? (
                  <Box
                    className="c-image c-item-image"
                    onClick={handleFileClick}
                  >
                    <Iconify
                      sx={{
                        width: 40,
                      }}
                      icon="mdi:camera-plus"
                    />
                    <Typography
                      style={{
                        fontSize: 12,
                      }}
                    >
                      Upload image
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <img
                      src={
                        businessLogo
                          ? `${IMAGE_URL}store/logo/thumbnail?id=${storeId}&img_id=${businessLogo}`
                          : file
                      }
                      alt="img"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                    <IconButton
                      onClick={handleFileRemove}
                      className="close-image-ico"
                    >
                      <Iconify width={15} icon="material-symbols:close" />
                    </IconButton>
                  </>
                )}
              </Box>
              <Typography className="c-image-caption">
                Allowed *.jpeg, *.jpg, *.png max size of 1 MB
              </Typography>
            </Stack>
          </Box>
        </AppDialog>
      )}
    </>
  );
}

export default About;
